<template>
  <div>
    <highcharts :options="chartOptions" />
  </div>
</template>
<script>
export default {
  name: 'DashboardStatsComponent',
  data () {
    return {}
  },
  props: {
    chartOptions: Object
  }
}
</script>